import {IController} from "angular";
import * as angular from "angular";

export class PlanningAllocationResourcesSelectionTableRowCtrl implements IController {
  resource: any;
  isSelected: boolean;
  isDisabled: boolean;
  onToggle: Function;


  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningAllocationResourcesSelectionTableRow', {
    bindings: {
      resource: '<',
      isSelected: '<',
      isDisabled: '<',
      onToggle: '&'
    },
    template: require("./planning-allocation-resources-selection-table-row.html").default,
    controller: PlanningAllocationResourcesSelectionTableRowCtrl
  });
